import {jsx,Fragment}from'react/jsx-runtime';import {createContext,useContext,useEffect}from'react';import {datadogRum}from'@datadog/browser-rum';/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var DEFAULT_REPLAY_SAMPLE_RATE = 100;var DEFAULT_SAMPLE_RATE = 100;var DatadogRumContext = createContext(null);function useDatadogRum() {
    var rum = useContext(DatadogRumContext);
    if (rum === null) {
        return datadogRum;
    }
    return rum;
}function filterByDefined(value) {
    return typeof value !== 'undefined';
}function filterByUndefined(value) {
    return !filterByDefined(value);
}var OBJECT_TYPE_ERROR = new Error('Expected value to be an object.');function parseStringifiedObject(str) {
    var parsedStr = JSON.parse(str);
    if (typeof parsedStr !== 'object' || parsedStr === null) {
        throw OBJECT_TYPE_ERROR;
    }
    return parsedStr;
}var DEFAULT_USER = {};
function useUser(user) {
    var _a = user !== null && user !== void 0 ? user : DEFAULT_USER, email = _a.email, id = _a.id, name = _a.name, restUser = __rest(_a, ["email", "id", "name"]);
    var rum = useDatadogRum();
    var restUserStr = JSON.stringify(restUser);
    useEffect(function () {
        var restUserParsed = parseStringifiedObject(restUserStr);
        var newUser = __assign(__assign({}, restUserParsed), { email: email, id: id, name: name });
        if (Object.values(newUser).every(filterByUndefined)) {
            return;
        }
        rum.setUser(newUser);
        return function () {
            rum.removeUser();
        };
    }, [email, id, name, restUserStr, rum]);
}function useDatadog(_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? true : _b, _c = _a.replaySampleRate, replaySampleRate = _c === void 0 ? DEFAULT_REPLAY_SAMPLE_RATE : _c, _d = _a.sampleRate, sampleRate = _d === void 0 ? DEFAULT_SAMPLE_RATE : _d, _e = _a.sessionReplayRecording, sessionReplayRecording = _e === void 0 ? true : _e, _f = _a.site, site = _f === void 0 ? 'datadoghq.com' : _f, _g = _a.trackInteractions, trackInteractions = _g === void 0 ? true : _g, user = _a.user, rumInitConfiguration = __rest(_a, ["enabled", "replaySampleRate", "sampleRate", "sessionReplayRecording", "site", "trackInteractions", "user"]);
    var rum = useDatadogRum();
    useEffect(function () {
        if (!enabled) {
            return;
        }
        rum.init(__assign({ replaySampleRate: replaySampleRate, sampleRate: sampleRate, site: site, trackInteractions: trackInteractions }, rumInitConfiguration));
    }, [
        enabled,
        replaySampleRate,
        rum,
        rumInitConfiguration,
        sampleRate,
        site,
        trackInteractions,
    ]);
    useEffect(function () {
        if (!enabled || !sessionReplayRecording) {
            return;
        }
        rum.startSessionReplayRecording();
        return function () {
            rum.stopSessionReplayRecording();
        };
    }, [enabled, rum, sessionReplayRecording]);
    useUser(user);
}function Datadog(_a) {
    var children = _a.children, enabled = _a.enabled, sessionReplayRecording = _a.sessionReplayRecording, user = _a.user, rumInitConfiguration = __rest(_a, ["children", "enabled", "sessionReplayRecording", "user"]);
    useDatadog(__assign({ enabled: enabled, sessionReplayRecording: sessionReplayRecording, user: user }, rumInitConfiguration));
    return jsx(Fragment, { children: children });
}function DatadogPrivacy(_a) {
    var children = _a.children, level = _a.level;
    return (jsx("span", __assign({ className: "dd-privacy-".concat(level), "data-dd-privacy": level }, { children: children })));
}function DatadogAllow(_a) {
    var children = _a.children;
    return jsx(DatadogPrivacy, __assign({ level: "allow" }, { children: children }));
}function DatadogHidden(_a) {
    var children = _a.children;
    return jsx(DatadogPrivacy, __assign({ level: "hidden" }, { children: children }));
}function DatadogMask(_a) {
    var children = _a.children;
    return jsx(DatadogPrivacy, __assign({ level: "mask" }, { children: children }));
}function DatadogMaskUserInput(_a) {
    var children = _a.children;
    return jsx(DatadogPrivacy, __assign({ level: "mask-user-input" }, { children: children }));
}export{DatadogAllow,DatadogHidden,DatadogMask,DatadogMaskUserInput,Datadog as default,useDatadogRum};